module.exports = "/dist/f2022ecd65a0703ec3edcb7641709a75.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200.woff
// module id = 112
// module chunks = 0